import { gql } from '@apollo/client';

export const GET_ALL_PROPOSALS = gql`
  query FetchProposals(
    $limit: Float
    $cursorPaging: String
    $search: String
    $selectedDate: [String!]
    $filterItems: [FilterItems!]
    $filterTags: FilterTags!
    $spamUrl: String = null
    $teamList: [TeamList!]
    $sort: String
  ) {
    fetchProposals(
      limit: $limit
      cursorPaging: $cursorPaging
      search: $search
      selectedDate: $selectedDate
      filterItems: $filterItems
      filterTags: $filterTags
      spamUrl: $spamUrl
      teamList: $teamList
      sort: $sort
    ) {
      proposalsStats(selectedDate: $selectedDate) {
        approvedCount
        notDraftCount
      }
      pagingMetadata {
        cursor
        hasNext
      }
      proposals {
        _id
        pid
        uid
        auid
        pnum
        name
        state
        isManager
        lastStatusUpdateTime
        isOwner
        language
        channel
        isSecured
        lockedData
        client {
          contact
          name
          desc
          address
          text
          email
        }
        draft {
          header
          variables
        }
        quotes {
          minPrice
          maxPrice
          hasNegativePrice
        }
        seenTime
        seenCount
        lastSeen
        date
        version
        project {
          name
          type
          othertype
          desc
        }
        approvedmanually
        tags
        deliverables
        pricing
        sawyou
        sawmilestones
        priceSeperator
        signature {
          clientIP
          date
        }
        emailLogs {
          date
          recipient
          type
          event
        }
        openLogs {
          date
          clientIP
          duration
          watched
          pageTime
          deviceInfo {
            deviceType
            deviceOS
            deviceBrowser
            deviceName
            deviceAgent
          }
          type
          event
          recipient
        }
        fonts {
          family
          weights
          source
          title
          format
          url
        }
        sharedViaMail
        isScheduled
        emailSettings {
          scheduled {
            status
            utcTime
            scheduleTime
            timezone
          }
          publishedProposalToProspect {
            status
            sent
            date
            reminder
            customize {
              subjectLine {
                RTL
                value
              }
              previewText {
                RTL
                value
              }
              emailBody {
                RTL
                value
              }
              buttonText {
                RTL
                value
              }
              reminder
            }
          }
          reminderToProspect {
            status
            sent
            date
            reminder
            customize {
              subjectLine {
                RTL
                value
              }
              previewText {
                RTL
                value
              }
              emailBody {
                RTL
                value
              }
              buttonText {
                RTL
                value
              }
              reminder
            }
          }
          secondReminderToProspect {
            status
            sent
            date
            reminder
            customize {
              subjectLine {
                RTL
                value
              }
              previewText {
                RTL
                value
              }
              emailBody {
                RTL
                value
              }
              buttonText {
                RTL
                value
              }
              reminder
            }
          }
          signedPDFToProspect {
            status
            sent
            date
            reminder
            customize {
              subjectLine {
                RTL
                value
              }
              previewText {
                RTL
                value
              }
              emailBody {
                RTL
                value
              }
              buttonText {
                RTL
                value
              }
              reminder
            }
          }
          recipients {
            firstName
            lastName
            email
          }
        }
        prevState
      }
    }
  }
`;

export const GET_SINGLE_PROPOSAL = gql`
  query FetchProposal($_id: String, $pid: String, $cid: String, $viewToken: String) {
    fetchProposal(_id: $_id, pid: $pid, cid: $cid, viewToken: $viewToken) {
      _id
      pid
      uid
      auid
      draftRev
      pnum
      name
      state
      channel
      draft
      email
      edited
      isSecured
      sharePasswordOverEmail
      lastStatusUpdateTime
      password
      client {
        contact
        name
        desc
        address
        text
        email
      }
      seenTime
      seenCount
      lastSeen
      emailLogs {
        date
        recipient
        type
        event
      }
      openLogs {
        date
        clientIP
        duration
        watched
        pageTime
        deviceInfo {
          deviceType
          deviceOS
          deviceBrowser
          deviceName
          deviceAgent
        }
      }
      date
      project {
        name
        type
        othertype
        name
        desc
        goals
      }
      approvedmanually
      version
      sawyou
      pricing
      deliverables
      milestones
      sawmilestones
      superPowers
      curr
      priceSeperator
      lockedData
      decimalPrecision
      language
      expiryDate
      expiryMessage
      currency
      callButton
      contactButton
      contactnumber
      enablePayment
      clientPayableAmount
      clientPayableLabel
      clientPayableCurrency
      clientPayableLink
      editEvent
      enableAITool
      userway
      creatorUserway
      scripts
      chatway
      chatwayScripts
      stripe {
        stripe_user_id
        isActive
        currency
        country
        isSquareConnected
        type
      }
      payment {
        status
        amount
        currency
        payment_intend
        created
      }
      published
      disableSig
      signatureEmails
      selectedOption
      prevState
      payedfor
      dateFormat
      redirectTo
      redirectAfter
      proposalRedirectAfter
      proposalRedirectTo
      sigOptions
      contactOptions {
        option
        value
        enabled
      }
      sigtype
      signature {
        name
        myname
        additionalSignature
        signatureBackgroundColor
        signatureTextColor
        additionalSignatureBackgroundColor
        additionalSignatureTextColor
        email
        date
        clientIP
        device
      }
      attachments {
        name
        type
        url
        size
      }
      isEditing {
        name
        uid
        tabID
      }
      importedProposal
      spamUrls {
        url
        blocked
      }
      wixConnectedInstance
      fromUserTemplate
      isBasicTemplate
      wixProposalId
      wixPricing {
        lineItems {
          quantity
          name
          description
          price
          pricesBreakdown {
            totalPriceAfterTax
            taxDetails {
              taxRate
              taxableAmount
              taxable
              totalTax
              taxName
              rateBreakdown {
                rate
                taxableAmount
                tax
              }
            }
            totalDiscount
            price
            priceBeforeDiscounts
            lineItemPrice
            fullPrice
          }
          itemType {
            preset
          }
        }
        appliedDiscounts {
          discountType
          lineItemIds
        }
        additionalFees {
          name
          priceBeforeTax
          taxDetails {
            taxRate
            taxableAmount
            taxable
            totalTax
            taxName
            rateBreakdown {
              rate
              taxableAmount
              tax
            }
          }
          price
        }
        calculatedTotals {
          priceSummary {
            total
            subtotal
            discount
            additionalFees
          }
        }
        paymentSettings {
          type
          singlePaymentSchedule {
            dueDate
            dueDateOffset
            issueDate
            deposit {
              percentage
              amount
            }
            paymentStatus
            amountPaid
          }
          multiplePaymentSchedule {
            items {
              dueDate
              dueDateOffset
              issueDate
              deposit {
                percentage
                amount
              }
              issueDateOffset
              title
              percentage
              amount
              paymentStatus
              amountPaid
            }
          }
        }
        currencyCode
        locale {
          country
          language
        }
      }
      isWixTemplate
      fonts {
        family
        weights
        source
        title
        format
        url
      }
      sharedViaMail
      isScheduled
      emailSettings {
        scheduled {
          status
          utcTime
          scheduleTime
          timezone
        }
        publishedProposalToProspect {
          status
          sent
          date
          reminder
          customize {
            subjectLine {
              RTL
              value
            }
            previewText {
              RTL
              value
            }
            emailBody {
              RTL
              value
            }
            buttonText {
              RTL
              value
            }
            reminder
          }
        }
        reminderToProspect {
          status
          sent
          date
          reminder
          customize {
            subjectLine {
              RTL
              value
            }
            previewText {
              RTL
              value
            }
            emailBody {
              RTL
              value
            }
            buttonText {
              RTL
              value
            }
            reminder
          }
        }
        secondReminderToProspect {
          status
          sent
          date
          reminder
          customize {
            subjectLine {
              RTL
              value
            }
            previewText {
              RTL
              value
            }
            emailBody {
              RTL
              value
            }
            buttonText {
              RTL
              value
            }
            reminder
          }
        }
        signedPDFToProspect {
          status
          sent
          date
          reminder
          customize {
            subjectLine {
              RTL
              value
            }
            previewText {
              RTL
              value
            }
            emailBody {
              RTL
              value
            }
            buttonText {
              RTL
              value
            }
            reminder
          }
        }
        recipients {
          firstName
          lastName
          email
        }
      }
      pipedriveDealId
      hubspot {
        hubspotObjectType
        hubspotContactId
        hubspotDealId
        hubspotCompanyId
      }
    }
  }
`;

export const FETCH_OR_CREATE_WIX_PROPOSAL = gql`
  query fetchOrCreateWixProposal(
    $wixProposalId: String
    $type: String!
    $templateId: String
    $wixTemplateId: String
  ) {
    fetchOrCreateWixProposal(
      wixProposalId: $wixProposalId
      type: $type
      templateId: $templateId
      wixTemplateId: $wixTemplateId
    ) {
      _id
      pid
      uid
      auid
      wixProposalId
      pnum
      name
      state
      draft
      email
      edited
      noTemplate
      client {
        contact
        name
        desc
        address
        text
        email
      }
      seenTime
      seenCount
      lastSeen
      emailLogs {
        date
        recipient
        type
        event
      }
      openLogs {
        date
        clientIP
        duration
        watched
        pageTime
        deviceInfo {
          deviceType
          deviceOS
          deviceBrowser
          deviceName
          deviceAgent
        }
      }
      date
      project {
        name
        type
        othertype
        name
        desc
        goals
      }
      approvedmanually
      version
      sawyou
      pricing
      deliverables
      milestones
      sawmilestones
      superPowers
      curr
      priceSeperator
      lockedData
      decimalPrecision
      language
      expiryDate
      expiryMessage
      currency
      callButton
      contactButton
      contactnumber
      enablePayment
      clientPayableAmount
      clientPayableLabel
      clientPayableCurrency
      clientPayableLink
      editEvent
      enableAITool
      userway
      creatorUserway
      scripts
      chatwayScripts
      stripe {
        stripe_user_id
        isActive
        currency
        country
        isSquareConnected
        type
      }
      payment {
        status
        amount
        currency
        payment_intend
        created
      }
      published
      disableSig
      signatureEmails
      selectedOption
      prevState
      payedfor
      dateFormat
      redirectTo
      redirectAfter
      sigOptions
      contactOptions {
        option
        value
        enabled
      }
      sigtype
      signature {
        name
        myname
        additionalSignature
        signatureBackgroundColor
        signatureTextColor
        additionalSignatureBackgroundColor
        additionalSignatureTextColor
        email
        date
        clientIP
        device
      }
      attachments {
        name
        type
        url
        size
      }
      isEditing {
        name
        uid
        tabID
      }
      importedProposal
      wixConnectedInstance
      fromUserTemplate
      isBasicTemplate
      wixProposalId
      wixPricing {
        lineItems {
          quantity
          name
          description
          price
          pricesBreakdown {
            totalPriceAfterTax
            taxDetails {
              taxRate
              taxableAmount
              taxable
              totalTax
              taxName
              rateBreakdown {
                rate
                taxableAmount
                tax
              }
            }
            totalDiscount
            price
            priceBeforeDiscounts
            lineItemPrice
            fullPrice
          }
          itemType {
            preset
          }
        }
        appliedDiscounts {
          discountType
          lineItemIds
        }
        additionalFees {
          name
          priceBeforeTax
          taxDetails {
            taxRate
            taxableAmount
            taxable
            totalTax
            taxName
            rateBreakdown {
              rate
              taxableAmount
              tax
            }
          }
          price
        }
        calculatedTotals {
          priceSummary {
            total
            subtotal
            discount
            additionalFees
          }
        }
        paymentSettings {
          type
          singlePaymentSchedule {
            dueDate
            dueDateOffset
            issueDate
            deposit {
              percentage
              amount
            }
            paymentStatus
            amountPaid
          }
          multiplePaymentSchedule {
            items {
              dueDate
              dueDateOffset
              issueDate
              deposit {
                percentage
                amount
              }
              issueDateOffset
              title
              percentage
              amount
              paymentStatus
              amountPaid
            }
          }
        }
        currencyCode
        locale {
          country
          language
        }
      }
      isWixTemplate
    }
  }
`;

export const DOWNLOAD_PROPOSAL = gql`
  query DownloadProposal($origin: String, $proposalId: String, $cid: String) {
    downloadProposal(origin: $origin, proposalId: $proposalId, cid: $cid)
  }
`;

export const DOWNLOAD_PROPOSAL_PDF = gql`
  query DownloadProposalPDF($proposalId: String) {
    downloadProposalPDF(proposalId: $proposalId)
  }
`;

export const GET_PROPOSALS_CLIENTS = gql`
  query FetchProposalsQuery($uid: String!) {
    fetchProposals(uid: $uid) {
      proposals {
        _id
        pid
        uid
        client {
          contact
        }
      }
    }
  }
`;

export const GET_APPROVED_PROPOSALS = gql`
  query FetchApprovedProposals($limit: Float, $cursorPaging: String) {
    fetchApprovedProposals(limit: $limit, cursorPaging: $cursorPaging) {
      proposalsCount
      pagingMetadata {
        cursor
        hasNext
      }
      proposals {
        _id
        pid
        uid
        auid
        pnum
        name
        state
        isManager
        isOwner
        language
        channel
        isSecured
        client {
          contact
          name
          desc
          address
          text
          email
        }
        draft {
          header
          variables
        }
        quotes {
          minPrice
          maxPrice
          hasNegativePrice
        }
        seenTime
        seenCount
        lastSeen
        date
        version
        project {
          name
          type
          othertype
          desc
        }
        approvedmanually
        tags
        deliverables
        pricing
        sawyou
        sawmilestones
        priceSeperator
        lockedData
        signature {
          clientIP
          date
        }
        emailLogs {
          date
          recipient
          type
          event
        }
        openLogs {
          date
          clientIP
          duration
          watched
          pageTime
          deviceInfo {
            deviceType
            deviceOS
            deviceBrowser
            deviceName
            deviceAgent
          }
          type
          event
          recipient
        }
        prevState
      }
    }
  }
`;

export const PROPOSAL_CSV = gql`
  query fetchProposalCSVQuery($duration: String!) {
    fetchProposalCSV(duration: $duration) {
      name
      clientName
      watched
      opened
      status
      quote
      clientIP
      tags
    }
  }
`;

export const USER_PROPOSALS_SUMMARY = gql`
  query fetchUserProposalsSummaryQuery {
    fetchUserProposalsSummary {
      duration
      total
      pending
    }
  }
`;

export const GET_IMPORT_PROPOSALS = gql`
  query getImportProposalsQuery(
    $limit: Float
    $cursorPaging: String
    $uid: String!
    $search: String
  ) {
    fetchProposals(limit: $limit, cursorPaging: $cursorPaging, uid: $uid, search: $search) {
      pagingMetadata {
        cursor
        hasNext
      }
      proposals {
        _id
        pid
        uid
        draft {
          header
        }
        date
        version
        project {
          name
        }
      }
    }
  }
`;

export const GET_IMPORT_PROPOSAL = gql`
  query getImportProposalQuery($_id: String) {
    fetchProposal(_id: $_id) {
      _id
      pid
      uid
      auid
      draft
    }
  }
`;

export const GET_REDIRECTION_PROPOSAL = gql`
  query FetchProposalRedirection($domain: String, $proposal: String) {
    fetchProposalRedirection(domain: $domain, proposal: $proposal) {
      _id
      wixProposalId
    }
  }
`;

export const OPEN_AI_RECOMMENDATIONS = gql`
  query openAIRecommendationsQuery(
    $prompt: String!
    $tone: String
    $recommendationSize: String
    $command: String
    $enhance: Boolean
    $grammar: Boolean
    $language: String
  ) {
    openAIRecommendations(
      prompt: $prompt
      tone: $tone
      recommendationSize: $recommendationSize
      command: $command
      enhance: $enhance
      grammar: $grammar
      language: $language
    ) {
      text
    }
  }
`;

export const GET_SPAM_PROPOSALS = gql`
  query FetchProposals($limit: Float, $cursorPaging: String, $spamUrl: String!) {
    fetchProposals(limit: $limit, cursorPaging: $cursorPaging, spamUrl: $spamUrl) {
      pagingMetadata {
        cursor
        hasNext
      }
      proposals {
        _id
        pid
        uid
        email
        pnum
        state
        date
        spamUrls {
          url
          blocked
        }
        project {
          name
        }
      }
    }
  }
`;

export const GET_BRANDING_DETAIL = gql`
  query fetchBrandingDetails($pid: String) {
    fetchBranding(pid: $pid) {
      companyName
      logo
    }
  }
`;

export const GENERATE_AI_IMAGES = gql`
  query GenerateAIImages($prompt: String!, $max: Float, $imageType: String) {
    generateAIImages(prompt: $prompt, max: $max, imageType: $imageType)
  }
`;

export const UPLOAD_AI_IMAGE = gql`
  query UploadAIImage($imageUrl: String!, $filePath: String!) {
    uploadAIImage(imageUrl: $imageUrl, filePath: $filePath)
  }
`;
